var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { name: "verifyCreditCardForm", novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c("Field", {
                  attrs: {
                    label: _vm.$t(
                      "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT"
                    ),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t(
                      "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT_TT"
                    )
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "col-sm-3" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "btn btn-default btn-file btn-sm"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("BROWSE")) +
                                      "\n            "
                                  ),
                                  _c("input", {
                                    ref: "kycFront",
                                    attrs: {
                                      type: "file",
                                      accept: _vm.verifyConfig.allowedMimeTypes.join(
                                        ","
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectKycImage(
                                          $event,
                                          "front"
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-offset-4 col-sm-8 col-md-9 col-md-offset-3"
                    },
                    [
                      _c("i18n", {
                        staticClass: "m-b-15",
                        attrs: {
                          path:
                            "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT_EXAMPLE",
                          tag: "p"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "instruction",
                              fn: function() {
                                return [
                                  _c("u", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT_EXAMPLE_INSTRUCTION"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _vm.frontMaxFileSize
                        ? _c("p", { staticClass: "text-danger m-b-20" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ACCOUNT_BILLING_CC_VERIFY_MODAL_MAX_FILE_SIZE_ERROR"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.frontFileInvalid
                        ? _c("p", { staticClass: "text-danger m-b-20" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ACCOUNT_BILLING_CC_VERIFY_MODAL_FILE_ERROR"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedKycFront
                        ? _c("img", {
                            attrs: {
                              width: _vm.verifyConfig.previewSize,
                              src: _vm.selectedKycFront
                            }
                          })
                        : _c("img", {
                            attrs: {
                              width: _vm.verifyConfig.previewSize,
                              src: require("@/assets/images/cc_front.png")
                            }
                          })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("Field", {
                  attrs: {
                    label: _vm.$t(
                      "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_BACK"
                    ),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t(
                      "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_BACK_TT"
                    )
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "col-sm-3" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "btn btn-default btn-file btn-sm"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("BROWSE")) +
                                      "\n            "
                                  ),
                                  _c("input", {
                                    ref: "kycBack",
                                    attrs: {
                                      type: "file",
                                      accept: _vm.verifyConfig.allowedMimeTypes.join(
                                        ","
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectKycImage(
                                          $event,
                                          "back"
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-offset-4 col-sm-8 col-md-9 col-md-offset-3"
                    },
                    [
                      _vm.backMaxFileSize
                        ? _c("p", { staticClass: "text-danger m-b-20" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ACCOUNT_BILLING_CC_VERIFY_MODAL_MAX_FILE_SIZE_ERROR"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.backFileInvalid
                        ? _c("p", { staticClass: "text-danger m-b-20" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ACCOUNT_BILLING_CC_VERIFY_MODAL_FILE_ERROR"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedKycBack
                        ? _c("img", {
                            attrs: {
                              width: _vm.verifyConfig.previewSize,
                              src: _vm.selectedKycBack
                            }
                          })
                        : _c("img", {
                            attrs: {
                              width: _vm.verifyConfig.previewSize,
                              src: require("@/assets/images/cc_back.png")
                            }
                          })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("Field", {
                  attrs: {
                    label: _vm.$t(
                      "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_ID"
                    ),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t(
                      "ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_ID_TT"
                    )
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "col-sm-3" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "btn btn-default btn-file btn-sm"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("BROWSE")) +
                                      "\n            "
                                  ),
                                  _c("input", {
                                    ref: "kycId",
                                    attrs: {
                                      type: "file",
                                      accept: _vm.verifyConfig.allowedMimeTypes.join(
                                        ","
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectKycImage($event, "id")
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-offset-4 col-sm-8 col-md-9 col-md-offset-3"
                    },
                    [
                      _vm.idMaxFileSize
                        ? _c("p", { staticClass: "text-danger m-b-20" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ACCOUNT_BILLING_CC_VERIFY_MODAL_MAX_FILE_SIZE_ERROR"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.idFileInvalid
                        ? _c("p", { staticClass: "text-danger m-b-20" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ACCOUNT_BILLING_CC_VERIFY_MODAL_FILE_ERROR"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedKycId
                        ? _c("img", {
                            attrs: {
                              width: _vm.verifyConfig.previewSize,
                              src: _vm.selectedKycId
                            }
                          })
                        : _c("img", {
                            attrs: {
                              width: _vm.verifyConfig.previewSize,
                              src: require("@/assets/images/drivers_licence.png")
                            }
                          })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row display-flex flex--justify-end p-t-25" },
                  [
                    _c(
                      "PrimaryButton",
                      {
                        staticClass: "p-r-25 p-l-25",
                        attrs: {
                          disabled:
                            _vm.formInvalid || _vm.isVerifyingCreditCard,
                          "show-loader-on-form": _vm.isVerifyingCreditCard
                        }
                      },
                      [
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value:
                                "ACCOUNT_BILLING_CC_VERIFY_MODAL_VERIFY_BUTTON",
                              expression:
                                "'ACCOUNT_BILLING_CC_VERIFY_MODAL_VERIFY_BUTTON'"
                            }
                          ]
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("button", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "CANCEL",
                          expression: "'CANCEL'"
                        }
                      ],
                      staticClass: "btn btn-danger m-l-15",
                      on: { click: _vm.onCloseModal }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }